import { Livechat } from "@api";
import { IRoom } from "@types";

export const subscribeRoom = async () => {
  Livechat.unsubscribeAll();
  const result: IRoom = await Livechat.room();
  Livechat.subscribeRoom(result._id);
  return result;
};
